module.exports = __webpack_public_path__ + "images/emoji/arrow_right.28868cdba45e3960dded.png";